module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "card-spacing",
    attrs: {
      "id": "insulin-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), (_vm.data.units !== null) ? _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardLatestReading')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(((_vm.data.units) + " " + _vm.lowerCaseUnitsLabel))
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.basal !== null) ? _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardInsulinLatestBasal')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(((_vm.data.basal) + " " + _vm.lowerCaseUnitsLabel))
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.bolus !== null) ? _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardInsulinLatestBolus')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(((_vm.data.bolus) + " " + _vm.lowerCaseUnitsLabel))
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.correction !== null) ? _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardInsulinLatestCorrection')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(((_vm.data.correction) + " " + _vm.lowerCaseUnitsLabel))
    }
  })])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "17px",
      "viewBox": "24 191 16 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.8354615,192.110676 C39.6853846,191.963108 39.4416923,191.963108 39.2916154,192.110676 L36.9870769,194.375519 L36.7159231,194.109187 C36.4047692,193.803544 35.9911538,193.635187 35.5511538,193.635187 C35.1109231,193.635187 34.6970769,193.803695 34.386,194.10964 L26.7518462,201.615245 L26.2917692,201.163244 C26.1789231,201.052417 26.029,200.99141 25.8694615,200.99141 C25.7098462,200.99141 25.5598462,201.052568 25.4476923,201.162866 L25.4374615,201.172845 C25.2047692,201.401832 25.2048462,201.774228 25.4376923,202.002912 L26.3272308,202.87675 L25.0699231,204.11293 L25.0356154,204.079213 C24.922,203.967631 24.7711538,203.906245 24.6106154,203.906245 C24.45,203.906245 24.2989231,203.967706 24.1843077,204.080423 L24.1758462,204.08889 C23.9413846,204.319237 23.9413846,204.694128 24.1758462,204.924551 L26.8508462,207.552416 C26.9644615,207.663999 27.1153077,207.725385 27.2758462,207.725385 C27.4365385,207.725385 27.5875385,207.663848 27.701,207.552265 L27.7106154,207.542815 C27.9450769,207.312468 27.9450769,206.937577 27.7106154,206.707154 L27.6746154,206.67185 L28.9319231,205.435745 L29.8194615,206.307618 C29.9323077,206.418445 30.0823077,206.479453 30.2417692,206.479453 C30.4013846,206.479453 30.5513846,206.418369 30.6640769,206.307543 L30.6737692,206.298017 C30.9064615,206.069106 30.9063846,205.69671 30.6735385,205.46795 L30.2056154,205.008238 L37.8397692,197.502633 C38.482,196.871238 38.4818462,195.844087 37.8393846,195.212843 L37.531,194.909922 L39.8353846,192.64523 C39.9856923,192.497662 39.9856923,192.258319 39.8354615,192.110676 L39.8354615,192.110676 Z M37.2957692,196.968231 L33.3056154,200.891242 L32.9046923,200.497376 L36.2495385,197.210144 C36.3997692,197.062501 36.3997692,196.823158 36.2495385,196.67559 C36.238,196.664251 36.2250769,196.655481 36.2125385,196.64588 C36.2027692,196.633482 36.1936923,196.620706 36.1820769,196.609291 L35.4078462,195.848472 C35.2576154,195.700829 35.0141538,195.700829 34.8639231,195.848472 C34.7137692,195.996115 34.7137692,196.235383 34.864,196.383026 L35.4337692,196.942905 L35.055,197.31515 L34.4850769,196.75512 C34.3348462,196.607477 34.0913846,196.607477 33.9411538,196.75512 C33.791,196.902763 33.791,197.142031 33.9412308,197.289674 L34.511,197.849553 L34.1322308,198.221798 L33.5624615,197.661843 C33.4123846,197.514276 33.1686923,197.514276 33.0186154,197.661843 C32.8683846,197.809486 32.8683846,198.04883 33.0186154,198.196397 L33.5883077,198.756352 L33.2095385,199.128597 L32.6397692,198.568642 C32.4896923,198.421075 32.246,198.421075 32.0959231,198.568642 C31.9456923,198.716285 31.9456923,198.955629 32.0959231,199.103196 L32.6656154,199.663076 L32.3606154,199.962746 L30.9398462,198.566979 L34.93,194.643967 C35.0959231,194.480827 35.3164615,194.391016 35.5511538,194.391016 C35.7856923,194.391016 36.0061538,194.480751 36.172,194.643665 L37.2954615,195.747322 C37.638,196.08396 37.6380769,196.631592 37.2957692,196.968231 L37.2957692,196.968231 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#34CAB9",
      "fill-rule": "evenodd",
      "transform": "translate(31.974063, 199.862692) scale(-1, -1) translate(-31.974063, -199.862692) "
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpen
    },
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'remove'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "250",
      "data-vv-rules": 'required|min_value:0|max_value:250',
      "data-vv-name": "units",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelUnits'),
      "errorText": _vm.errors.first('units'),
      "type": "number",
      "label": _vm.$t('message.labelUnits'),
      "hintText": ((_vm.$t('message.cardInsulin')) + " " + _vm.lowerCaseUnitsLabel),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.units),
      callback: function($$v) {
        _vm.$set(_vm.model, "units", _vm._n($$v))
      },
      expression: "model.units"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "hintText": _vm.$t('message.selectText'),
      "data-vv-rules": 'required',
      "data-vv-as": _vm.$t('message.labelInsulinType'),
      "data-vv-name": "insulin_type",
      "data-vv-value-path": "inputValue",
      "scroller": _vm.scroller,
      "errorText": _vm.errors.first('insulin_type'),
      "label": _vm.$t('message.labelInsulinType'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.type),
      callback: function($$v) {
        _vm.$set(_vm.model, "type", $$v)
      },
      expression: "model.type"
    }
  }, _vm._l((_vm.insulinTypes), function(type, index) {
    return _c('mu-menu-item', {
      key: 'insulin-type' + index,
      attrs: {
        "value": type.insulin_type_id,
        "title": _vm.mapInsulinTypes(type.type)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20a3c8ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Input/Insulin/Insulin.vue
// module id = 3078
// module chunks = 1